var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-6"},[_c('div',{staticClass:"mb-4 flex flex-wrap items-center gap-2"},[_c('h5',[_c('i',{staticClass:"dot"}),_vm._t("title",function(){return [_vm._v(_vm._s(_vm.title))]})],2),_c('div',{staticClass:"ml-auto"},[_vm._t("right")],2)]),_c('div',{staticClass:"grid xl:grid-cols-12"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }